export const PAGE_ACCENTS = {
  dashboard: { light: '#9B5B00', dark: '#F0C36D' },
  reports: { light: '#4F5DA8', dark: '#B7C0FF' },
  companies: { light: '#147D78', dark: '#7DD8CF' },
  users: { light: '#7653A9', dark: '#C4A6F1' },
  customers: { light: '#BE4F45', dark: '#FF9B91' },
  items: { light: '#2875A6', dark: '#86C9F3' },
  sales: { light: '#B85C18', dark: '#FFB37D' },
  debts: { light: '#A34569', dark: '#F09AB8' },
  expenses: { light: '#74720C', dark: '#DBD875' },
  help: { light: '#2E7161', dark: '#85D3B9' },
  faq: { light: '#4C5FA5', dark: '#ABB7FF' },
  profile: { light: '#96586B', dark: '#E8AAB8' },
} as const;

export type PageAccentName = keyof typeof PAGE_ACCENTS;

export const NAV_PAGE_ACCENTS: Record<string, PageAccentName> = {
  '/dashboard': 'dashboard',
  '/reports': 'reports',
  '/companies': 'companies',
  '/users': 'users',
  '/customers': 'customers',
  '/items': 'items',
  '/sales': 'sales',
  '/debts': 'debts',
  '/expenses': 'expenses',
  '/help': 'help',
  '/faq': 'faq',
};
